import React from "react";
import ListView from "../../../shared/components/ListView";
import ProviderRow from "./CustomTable";
import { ProviderTableColumns, Search } from "../../../configs/provider";
import { ProviderSortTypes } from "../../../configs/sortTypes";

const Content = () => {
  return (
    <ListView
      url="/materials/providers/"
      sortTypes={ProviderSortTypes}
      rowElement={ProviderRow}
      tableColumns={ProviderTableColumns}
      textString={Search.searchText}
    />
  )
}

export default Content;